export default {"src":"/_next/static/media/open_eye.d7011290.svg","height":25,"width":25};